import './index.css';

import { Button, CircularProgress, FormControlLabel, Grid, Switch } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import MyIcon from 'components/Icon';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import { functions } from 'helpers';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import type { QuickviewProps, QuickviewStates } from './constants';
import type { IrregularProduct } from 'scenes/Producer/Product/MyProducts/constants';

class QuickView extends Component<QuickviewProps, QuickviewStates> {
  constructor(props: QuickviewProps) {
    super(props);

    this.state = {
      loading: true,
      idProductHistory: null,
      statusProduct: null,
    };

    this.handleCloseQuickView = this.handleCloseQuickView.bind(this);
  }

  handleCloseQuickView() {
    if (typeof this.props.changeActive === 'function') {
      this.props.changeActive();
    }

    this.setState({
      loading: true,
      idProductHistory: this.props.productData.id,
    });
  }

  getActionsMessage = (product: IrregularProduct) => {
    const { pending_actions } = product;
    const messages = [];

    if (pending_actions.above_commission_limit) {
      messages.push(
        <div style={{ paddingBottom: 8 }}>
          <Alert severity='warning'>
            Os produtos listados apresentam comissões que ultrapassam indevidamente o limite de 100%. Para evitar que esse valor adicional seja
            descontado das próximas transações, normalize esse cenário até 19/02.
          </Alert>
        </div>
      );
    }

    if (pending_actions.above_coproducers_limit) {
      messages.push(
        <div style={{ paddingBottom: 8 }}>
          <Alert severity='warning'>
            Os produtos listados abaixo contam com mais de 14 co-produtores cadastrados, sendo necessário a remoção dos excedentes até o dia 19/02.
            Por gentileza, regularize os cadastros
          </Alert>
        </div>
      );
    }

    if (pending_actions.commission_by_value) {
      messages.push(
        <div style={{ paddingBottom: 8 }}>
          <Alert severity='warning'>
            Os produtos listados abaixo estão configurados com a regra de comissão fixa por valor, a qual deixará de existir a partir do dia 19/02.
            Por gentileza, adapte para a regra de comissionamento percentual.
          </Alert>
        </div>
      );
    }

    if (pending_actions.invalid_physical_dimensions) {
      messages.push(
        <div style={{ paddingBottom: 8 }}>
          <Alert severity='warning'>
            Os produtos listados abaixo estão configurados com dimensões que não são aceitas pelos correios. Por gentileza, corrija as dimensões dos
            produtos.
          </Alert>
        </div>
      );
    }

    return messages;
  };

  getToggleStatus = () => {
    if (this.props.productStatus.isFetching) {
      return (
        <span style={{ position: 'relative', top: '3px' }}>
          <CircularProgress size={18} />
        </span>
      );
    }

    switch (this.state.statusProduct) {
      case 'active':
        return 'Ativo';
      case 'inactive':
        return 'Inativo';
      case 'filed':
        return 'Arquivado';
      default:
        return 'Sem status';
    }
  };

  getEditButton = (product: IrregularProduct) => {
    const { id, parent_product } = product;
    const baseRoute = '/producer/product/editproduct';
    const finalRoute = parent_product ? `${baseRoute}/${parent_product}/${id}/coproducers` : `${baseRoute}/${id}/coproducers`;

    return (
      <Link to={finalRoute}>
        <Button
          style={{
            color: '#596375',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>edit</Icon>
          Editar
        </Button>
      </Link>
    );
  };

  componentDidUpdate(prevProps: any) {
    const nextProps = this.props;

    if (prevProps.active === false && nextProps.active) {
      if (nextProps.productData.id && nextProps.productData.id !== this.state.idProductHistory) {
        this.setState({ loading: true });

        (async () => {
          // zerando todas as informações
          this.setState({
            loading: false,
            statusProduct: nextProps.productData.status,
          });
        })();
      } else {
        this.setState({ loading: false });
      }
    }
  }

  render() {
    const { productData, active } = this.props;

    // se o quickview estiver ativo, remove o scroll (rolon)
    this.props.active ? functions.removeScrollPage() : functions.addScrollPage();
    let labelToggleStatus = this.getToggleStatus();

    if (this.state.loading) {
      return (
        <>
          <div className={`my-quickview${this.props.active ? ' -active' : ''}`}>
            <div className='loading' style={{ height: '100%' }}>
              <Spin tip='Carregando produto ...' />
            </div>
          </div>
          <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'}></div>
        </>
      );
    }

    return (
      <>
        <div className={`my-quickview --quickView-product${active ? ' -active' : ''}`}>
          <div className='my-quickview__head'>
            <Grid container alignItems='center' direction='row' justifyContent='space-between'>
              <div className='my-quickview__title'>Produto: {productData.id}</div>
              <div className='my-quickview__close' onClick={this.handleCloseQuickView}>
                <MyIcon name='icon-close' />
              </div>
            </Grid>
          </div>

          <div className='my-quickview__container'>
            <Grid container>
              <Grid
                item
                className='product__image'
                xs={4}
                sm={4}
                style={{
                  backgroundImage: `url(${productData.image ? productData.image : ''})`,
                }}
              />

              <Grid item className='product__info' xs={8} sm={8}>
                <div className='product__name' title={productData.title ? productData.title : 'Produto desconhecido'}>
                  <Truncate count={40} final={'...'}>
                    {productData.title ? productData.title : 'Produto desconhecido'}
                  </Truncate>
                </div>

                <div className='m4' />
                <div className='product__status'>
                  {!productData.has_children && (
                    <FormControlLabel
                      label={labelToggleStatus}
                      control={
                        <Switch
                          color='default'
                          defaultChecked={this.state.statusProduct === 'active' ? true : false}
                          checked={this.state.statusProduct === 'active' ? true : false}
                          disabled={true}
                        />
                      }
                    />
                  )}
                </div>
              </Grid>

              <div className='m8' />

              <Grid item xs={12}>
                {this.getActionsMessage(productData)}
                {this.getEditButton(productData)}
              </Grid>
            </Grid>
          </div>
        </div>

        <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'} onClick={this.handleCloseQuickView}></div>
      </>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    productStatus: state.orbita.Product.productStatus,
  };
}
export default withRouter(connect(mapStateToProps)(QuickView));
